module.exports = __webpack_public_path__ + "img/depa.27b1e6c2.png";